var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpointsActiveM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1534 0.828295H7.84662C6.52833 0.828295 5.30768 1.53308 4.64747 2.67518L0.495157 9.86744C-0.165052 11.0095 -0.165052 12.417 0.495157 13.5612L4.64747 20.7556C5.30768 21.8977 6.5262 22.6025 7.84662 22.6025H16.1534C17.4717 22.6025 18.6923 21.8977 19.3525 20.7556L23.5048 13.5612C24.1651 12.4191 24.1651 11.0117 23.5048 9.86744L19.3525 2.67306C18.6923 1.53096 17.4738 0.826172 16.1534 0.826172V0.828295Z",
    fill: "#E60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39893 7.62244H16.5204V9.47183H10.1806V10.7397H15.5932V12.589H10.1806V14.1011H16.6015V15.9505H7.39893V7.62244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpointsActiveM);
export default __webpack_public_path__ + "static/media/epoints-active-M.6d2337540972e49c375be5d13b76c57f.svg";
export { ForwardRef as ReactComponent };